export const styles = () => ({
  title: {
    marginBottom: 12,
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '100%',
    color: '#354052',
    textAlign: 'center',
    letterSpacing: '-0.02em',
  },
})
